module.exports = __webpack_public_path__ + "static/videos/etch_006.ae5bc64.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/etching/etch_006.mp4
// module id = 468
// module chunks = 1